import { PageHeader, Skeleton } from "antd";
import { ReactNode, useEffect, useState } from "react"
import { getProjectService } from "../../backend";
import { Outlet } from "react-router-dom";
import { useRecoilState } from "recoil";
import { projectsState } from "../../recoil/project";
import { handleSetMixpanelUserGroups } from "../../backend/tracking";
import PageContentWrapper from "../../components/PageContentWrapper";
import PageHeaderBreadcrumb from "../../components/PageHeaderBreadcrumb";
import PageHeaderContent from "../../components/PageHeaderContent";
import { PlusCircleOutlined } from "@ant-design/icons";

const Projects = () => {
    const [projects, setProjects] = useRecoilState(projectsState)
    const [loadingProjects, setLoadingProjects] = useState(false);
    const [projectsSummary, setProjectsSummary] = useState<{ primaryText?: ReactNode; secondaryText?: ReactNode }[]>([]);

    useEffect(() => {
        const loadData = async () => {
            setLoadingProjects(true);
            try {
                const { data: { projects } } = await getProjectService().listProjects();
                const extended = await Promise.all(projects.map(project => getProjectService().getProject(project.id)));
                const finalProjects = extended.map(e => e.data);
                const allPaymentPlans = finalProjects.map(pr => pr.paymentPlan?.name);
                const plansSummary = [...new Set(allPaymentPlans)].map(t => {
                    const total = allPaymentPlans.filter(project => project === t).length;
                    return { secondaryText: `${total} ${t} ${total === 1 ? "Project" : "Projects"}` }
                })
                setProjectsSummary([
                    { primaryText: `${projects.length} Total ${projects.length === 1 ? "Project" : "Projects"}` },
                    ...plansSummary
                ]);
                setProjects(finalProjects);
                handleSetMixpanelUserGroups(finalProjects.map(item => item.id));
            } catch (error) {
            } finally {
                setLoadingProjects(false);
            }
        }

        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const headerBreadcrumb = !loadingProjects ?
        <PageHeaderBreadcrumb
            items={[
                { link: "/projects", name: "Projects" }
            ]}
        /> : <Skeleton.Button active={true} size="small" />;

    const headerContent = !loadingProjects ? (
        <PageHeaderContent
            title={{
                mainText: "Projects Overview"
            }}
            summary={projectsSummary}
            mainLinkButton={{
                link: "/pricing/new",
                title: <><PlusCircleOutlined /> Create Project</>
            }}
        />
    ) : <Skeleton.Input />

    return (
        <PageContentWrapper
            size="large"
            header={
                <PageHeader
                    title={headerBreadcrumb}
                    style={{ paddingTop: "8px" }}
                >
                    {headerContent}
                </PageHeader>
            }
            loading={loadingProjects}
        >
            {!loadingProjects ? <Outlet context={{ projects }} /> : <Skeleton />}
        </PageContentWrapper >
    )
}


export default Projects;